import {useEffect} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {useParams} from 'react-router'
import {useHistory} from 'react-router-dom'

import {useTranslation} from '../../../../hooks/useTranslation'

import {CustomerTierSettingsDetails} from './components/CustomerTierSettingsDetails'
import {useCustomerTierSettingEditMutation} from './hooks/useCustomerTierSettingsMutations'
import {useCustomerTierSettingsQuery} from './hooks/useCustomerTierSettingsQuery'
import {CustomerTierSettings} from './types/CustomerTierSettings'

export const CustomerTierSettingsEdit = () => {
  const {tierSettingsId} = useParams<{
    tierSettingsId?: string
  }>()

  const {t} = useTranslation()
  const history = useHistory()

  const customerTierSettingsMutation = useCustomerTierSettingEditMutation()
  const customerTierSettingsQuery = useCustomerTierSettingsQuery()

  const methods = useForm<CustomerTierSettings>({
    defaultValues: {} as CustomerTierSettings,
    mode: 'onChange'
  })

  useEffect(() => {
    if (tierSettingsId && customerTierSettingsQuery.data) {
      const setting = customerTierSettingsQuery.data.find(
        (setting) => setting.id === tierSettingsId
      )
      if (setting) {
        methods.reset(setting)
      }
    }
  }, [tierSettingsId, customerTierSettingsQuery.data, methods])

  const handleSaveButtonClick = async (data: CustomerTierSettings) => {
    try {
      await customerTierSettingsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  if (customerTierSettingsQuery.isLoading || !customerTierSettingsQuery.data) {
    return (
      <div>{t('configurations.hconnect.configurationDetails.configurationDetails.loading')}</div>
    )
  }

  return (
    <FormProvider {...methods}>
      <CustomerTierSettingsDetails
        mode="edit"
        configId={tierSettingsId}
        customerTierSetting={{} as CustomerTierSettings}
        onSaveButtonClick={methods.handleSubmit(handleSaveButtonClick)}
        isSubmitting={customerTierSettingsMutation.isLoading}
      />
    </FormProvider>
  )
}
